exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/object-get-own-property-symbols.js
// module id = 1701
// module chunks = 1